import { Component, HostListener } from '@angular/core';
import { DISEASE_SECTIONS } from '../../../../../shared/constants';

@Component({
    selector: 'disease-section-nav',
    templateUrl: './disease-section-nav.component.html',
    styleUrls: ['./disease-section-nav.component.scss'],
})
export class DiseaseSectionNavComponent {
    public links: { id: string; description: string; hidden: boolean }[] = Object.values(DISEASE_SECTIONS.about.sections || {});
    public isNavOpen = false;

    public jumpToSection(event: MouseEvent, id: string): void {
        event.preventDefault();
        this.isNavOpen = false;
        setTimeout(() => {
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }

    public toggleNav() {
        this.isNavOpen = !this.isNavOpen;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: UIEvent) {
        if ((event.target as Window).innerWidth >= 1200) {
            this.isNavOpen = false;
        }
    }
}
